import React, { useState, useEffect } from "react";
import "./ExclusiveMember.scss";
import MemberShipPlan from "../../../NewHomePage/MemberShipPlan";
import BillDetailsSec from "../../../BillingComp/BillDetailsSec";

const ExclusiveMember = ({ onJoinClick, userDetail }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBillModalOpen, setIsBillModalOpen] = useState(false);
  const [trialDetails, setTrialDetails] = useState({
    baseAmount: "",
    gst: "",
    total: "",
    days: "",
  });

  useEffect(() => {
    const fetchTrialDetails = async () => {
      try {
        const response = await fetch(
          "https://ballersapi.ballerslife.co/api/v1/memberships/payments/free_trial_payment/free_trial_gst_breakup",
          {
            method: "GET",
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        const data = await response.json();
        setTrialDetails({
          baseAmount: data["base amount"],
          gst: data["18%_gst"],
          total: data["total_trial_amount"],
          days: data["trial_period"],
        });
      } catch (error) {
        console.error("Error fetching trial details:", error);
      }
    };

    fetchTrialDetails();
  }, []);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [selectedPlan, setSelectedPlan] = useState(null);
  const handleSelectPlan = () => {
    setIsBillModalOpen(true);
  };

  const startFreeTrail = async () => {
    try {
      const response = await fetch(
        "https://ballersapi.ballerslife.co/api/v1/memberships/start_your_trial",
        {
          method: "POST",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: "",
        }
      );

      const data = await response.json();
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="membership-container">
      <h1 className="welcome">Welcome, {userDetail.member_name} !</h1>
      <p className="subtitle">
        Members Only:
        <br />
        Exclusive Access Required !
      </p>
      <p className="members-get">
        Looks like you’re trying to join an open game, <br /> but this feature
        is only for Ballers members.{" "}
      </p>
      <div className="join-button-container">
        {userDetail?.paid_trial_availed === false &&
        userDetail?.payment_status == "unpaid" ? (
          <>
            <button
              className="join-button-startFreeTrail"
              onClick={() => handleSelectPlan()}
            >
              Start Free Trial
            </button>
            <button className="join-button" onClick={openModal}>
              Membership Plans
            </button>
          </>
        ) : (
          <></>
        )}
        {userDetail?.is_trial_active === false &&
        userDetail?.payment_status == "unpaid" &&
        userDetail?.paid_trial_availed == true ? (
          <button
            className="join-button-startFreeTrail"
            onClick={startFreeTrail}
          >
            Start Free Trial
          </button>
        ) : (
          <></>
        )}
      </div>
      {isModalOpen && (
        <MemberShipPlan onClose={closeModal} userDetail={userDetail} />
      )}
      {isBillModalOpen && (
        <BillDetailsSec
          onClose={() => setIsBillModalOpen(false)}
          parentOnClose={handleSelectPlan}
          planName={"Ballers Trial"}
          amount={trialDetails.baseAmount}
          gst={trialDetails.gst}
          total={trialDetails.total}
          planId={""}
          days={trialDetails.days}
        />
      )}
    </div>
  );
};

export default ExclusiveMember;
